import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import * as AccountStepsViews from './AccountsStepViews';
import { isVisible } from '../../../AdvWorkflow/AdvWorkflowHelpers';

import AccountsOverview from './AccountsOverviewContainer';
import AccountAddEdit from './AccountAddEditContainer';
import { isNumeric, createCustomPropType } from '../../../../../js/app/react/validators';

class AccountsStepView extends Component {
  componentDidUpdate(prevProps) {
    const {
      branch, iterator, fetchData, workflowId, clientId, dirtyNodesMap,
    } = this.props;

    if (!isVisible(prevProps.branch, prevProps.iterator) && isVisible(branch, iterator)) {
      fetchData(workflowId, clientId, dirtyNodesMap);
    }
  }
  render() {
    const { branch, workflowId, viewId } = this.props;
    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        {...(viewId === AccountStepsViews.OVERVIEW
          ? {
              id: 'AccountsOverviewViewStep',
            }
          : {})}
      >
        {viewId === AccountStepsViews.OVERVIEW && (
          <AccountsOverview branch={branch} workflowId={workflowId} />
        )}
        {viewId === AccountStepsViews.ADD && (
          <AccountAddEdit branch={branch} workflowId={workflowId} />
        )}
        {viewId === AccountStepsViews.EDIT && (
          <AccountAddEdit branch={branch} workflowId={workflowId} />
        )}
      </AdvWorkflowStep>
    );
  }
}

AccountsStepView.defaultProps = {
  iterator: null,
};

AccountsStepView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number).isRequired,
  iterator: PropTypes.arrayOf(PropTypes.number),
  workflowId: PropTypes.string.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  viewId: PropTypes.oneOf(Object.values(AccountStepsViews)).isRequired,

  skip: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default AccountsStepView;
